import { render, staticRenderFns } from "./RoomManTree.vue?vue&type=template&id=27a2c84d&scoped=true&"
import script from "./RoomManTree.vue?vue&type=script&lang=js&"
export * from "./RoomManTree.vue?vue&type=script&lang=js&"
import style0 from "./RoomManTree.vue?vue&type=style&index=0&id=27a2c84d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2c84d",
  null
  
)

export default component.exports